<template>
  <default-layout>
    <event-navbar title="Event Home" />
    <v-runtime-template :template="event_header"></v-runtime-template>
    <div class="container">
      <recommendation-index compact />
    </div>
    <v-runtime-template :template="event_content"></v-runtime-template>
    <v-runtime-template :template="event_footer"></v-runtime-template>
    <hr class="mx-3">
    <p class="text-center text-muted small mb-4">
      <router-link to="/about">Über diese App</router-link>
    </p>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import VRuntimeTemplate from "v-runtime-template";
import DefaultLayout from '@/components/DefaultLayout.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import RecommendationIndex from '@/components/recommendation/recommendation-index.vue'

export default {
  name: 'EventHomeView',
  components: {
    VRuntimeTemplate, DefaultLayout, EventNavbar, RecommendationIndex
  },
  data() {
    return {
      // header/footer let the editor place content above and below the
      // recommendation teaser, so their own buttons need not be scrolled to.
      // Same pattern as the list views (see ListViewStorageMixin).
      event_header: '',
      event_content: '',
      event_footer: '',
    }
  },

  created() {
      this.$storage.fetchUser()  // to update the favorite storage
      let me = this
      if (navigator.onLine) {
        // One request already carries all three placeholders.
        this.$api.get(`zpcard/${this.$route.params.shortName}/`).then((response) => {
          me.setContent(response.data.header, response.data.html, response.data.footer)
          localStorage.setItem(me.storageKey(), JSON.stringify({
            header: me.event_header, html: me.event_content, footer: me.event_footer,
          }))
        })
      } else {
          me.loadFromCache()
      }
  },

  methods: {
    storageKey() {
      return `zpcard-event-home-${this.$route.params.shortName}`
    },
    setContent(header, html, footer) {
      this.event_header = header || ''
      this.event_content = html || ''
      this.event_footer = footer || ''
    },
    loadFromCache() {
      // Older builds cached the bare content HTML under a shared key; fall back
      // to it so an offline start right after the update still shows something.
      let raw = localStorage.getItem(this.storageKey())
        || localStorage.getItem('zpcard-event-home')
      if (!raw) return
      try {
        let cached = JSON.parse(raw)
        this.setContent(cached.header, cached.html, cached.footer)
      } catch (e) {
        this.setContent('', raw, '')
      }
    },
  },

}
</script>
